console.log("Hey! Welcome to our website. We hope you have a great day!");

import { Application } from "@hotwired/stimulus";
import AccordionController from "./controllers/accordion_controller";
import CarouselController from "./controllers/carousel_controller";
import FaqItemController from "./controllers/faq_item_controller";

// Start Stimulus application
const application = Application.start();

// Register your controllers
application.register("accordion", AccordionController);
application.register("carousel", CarouselController);
application.register("faq-item", FaqItemController);

// Other JS
function copyright() {
  var currentYear = new Date().getFullYear();
  var copyright = document.getElementById("copyright");

  copyright.innerHTML = "&copy; " + currentYear + " " + copyright.innerHTML;
}

copyright();

// Mobile menu functionality
document.addEventListener("DOMContentLoaded", function () {
  const mobileMenu = document.getElementById("mobile-menu");
  const menuButton = document.getElementById("mobile-menu-button");
  const closeButton = document.getElementById("mobile-menu-close");

  // Toggle menu when hamburger is clicked
  menuButton?.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    mobileMenu.classList.toggle("hidden");
    // Prevent body scroll when menu is open
    document.body.classList.toggle("overflow-hidden");
  });

  // Close menu when X button is clicked
  closeButton?.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    mobileMenu.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  });

  // Close menu when clicking outside
  document.addEventListener("click", (event) => {
    if (
      !mobileMenu.classList.contains("hidden") && // Menu is open
      !mobileMenu.contains(event.target) && // Click is outside menu
      event.target !== menuButton // Click is not on menu button
    ) {
      mobileMenu.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
  });

  // Close menu when ESC key is pressed
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !mobileMenu.classList.contains("hidden")) {
      mobileMenu.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
  });
});

// FAQ functionality
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    const button = item.querySelector("button");
    const content = item.querySelector("dd");
    const icon = item.querySelector("svg");

    button?.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";

      // Close all other FAQs
      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherButton = otherItem.querySelector("button");
          const otherContent = otherItem.querySelector("dd");
          const otherIcon = otherItem.querySelector("svg");

          otherButton.setAttribute("aria-expanded", "false");
          otherContent.classList.add("hidden");
          otherIcon.style.transform = "rotate(0deg)";
        }
      });

      // Toggle current FAQ
      button.setAttribute("aria-expanded", !isExpanded);
      content.classList.toggle("hidden");
      icon.style.transform = isExpanded ? "rotate(0deg)" : "rotate(45deg)";
    });
  });
});
